import React from 'react';
import { Select } from 'antd';
import { useField } from 'formik';
const handleChange = (value) => {
    console.log(`selected ${value}`);
};
const MultipleSelect = (props) => {
    const { options = [], placeholder, defaultValue = [], name, size = "default size", onChangeValue = () => { } } = props
    const [field, meta, helpers] = useField(name);
    return (
        < Select
            mode="multiple"
            style={{
                width: '100%',
            }}
            size={size}
            value={field.value}
            placeholder={placeholder}
            onChange={(value) => {
                helpers.setValue(value);
                onChangeValue(value)
            }}
            onBlur={() => helpers.setTouched(true)}
            options={options}
            status={meta.touched && meta.error && "error"}
        />
    )
};
export default MultipleSelect;